import styled from '@emotion/styled';
import { CardHeader, Typography, blue, grey, tokens } from '@galaxy-react/core';

export const SearchResultWrapperStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: tokens.spacingHorizontalXS,
  whiteSpace: 'nowrap',
});

export const SearchResultCardHeaderStyled = styled(CardHeader)({
  width: '100%',
  '&.fui-CardHeader': {
    gridRowGap: tokens.spacingHorizontalXS,
  },
  '& .fui-CardHeader__action': {
    gridRowStart: 'span 1',
  },

  '& .fui-CardHeader__description': {
    minWidth: '0',
  },
});

export const SearchResultCategoryStyled = styled('span')({
  fontSize: tokens.fontSizeBase200,
  color: grey[600],
});

export const SearchResultReportNameStyled = styled(Typography)({
  color: blue[700],
});

export const SearchOriginalNameStyled = styled('span')({
  '&::after': {
    content: '""',
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    marginLeft: tokens.spacingVerticalS,
    display: 'inline-block',
    verticalAlign: 'middle',
    backgroundColor: grey[600],
  },
});

export const SearchResultDescriptionStyled = styled('p')({
  margin: '0',
  color: grey[800],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const SearchResultReportDetailsStyled = styled('div')({
  fontSize: tokens.fontSizeBase200,
  fontWeight: tokens.fontWeightRegular,
  lineHeight: tokens.lineHeightBase200,
  color: grey[600],
  width: '100%',
});

export const SearchResultReportInfoStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: tokens.spacingHorizontalXS,
});

export const SearchViewsAndNameStyled = styled('div')({
  gap: tokens.spacingHorizontalS,
  display: 'flex',
});
